export default "__VITE_ASSET__Pl_ckMT7__"